var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-config-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("auth.authentication"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "authentication" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c("div", { staticClass: "admin-config-panel__inner" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                  keydown: function ($event) {
                    return _vm.configForm.errors.clear($event.target.name)
                  },
                },
              },
              [
                _c(
                  "section",
                  {
                    staticClass: "admin-config-section",
                    attrs: { "aria-label": _vm.trans("auth.authentication") },
                  },
                  [
                    _c("h4", { staticClass: "admin-config-section__title" }, [
                      _vm._v(_vm._s(_vm.trans("auth.authentication"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "admin-config-section__description" },
                      [
                        _vm._v(
                          "Session lifetime, password recovery, and lockout settings directly affect account access and support load."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 form-group" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("auth.token_lifetime") +
                                    " " +
                                    _vm.trans("auth.in_minute")
                                ) + " "
                              ),
                              _c("show-tip", {
                                attrs: {
                                  module: "auth",
                                  tip: "tip_token_lifetime",
                                  type: "field",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configForm.token_lifetime,
                                expression: "configForm.token_lifetime",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              value: "",
                              name: "token_lifetime",
                              placeholder: _vm.trans("auth.token_lifetime"),
                            },
                            domProps: { value: _vm.configForm.token_lifetime },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.configForm,
                                  "token_lifetime",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.configForm,
                              "prop-name": "token_lifetime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 form-group" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "auth.reset_password_token_lifetime"
                                  ) +
                                    " " +
                                    _vm.trans("auth.in_minute")
                                ) + " "
                              ),
                              _c("show-tip", {
                                attrs: {
                                  module: "auth",
                                  tip: "tip_reset_password_token_lifetime",
                                  type: "field",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.configForm.reset_password_token_lifetime,
                                expression:
                                  "configForm.reset_password_token_lifetime",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              value: "",
                              name: "reset_password_token_lifetime",
                              placeholder: _vm.trans(
                                "auth.reset_password_token_lifetime"
                              ),
                            },
                            domProps: {
                              value:
                                _vm.configForm.reset_password_token_lifetime,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.configForm,
                                  "reset_password_token_lifetime",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.configForm,
                              "prop-name": "reset_password_token_lifetime",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6 form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.trans("auth.reset_password")) + " "
                            ),
                            _c("show-tip", {
                              attrs: {
                                module: "auth",
                                tip: "tip_reset_password",
                                type: "field",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("switches", {
                              attrs: { theme: "bootstrap", color: "success" },
                              model: {
                                value: _vm.configForm.reset_password,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configForm,
                                    "reset_password",
                                    $$v
                                  )
                                },
                                expression: "configForm.reset_password",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6 form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.trans("auth.two_factor_security")) +
                                " "
                            ),
                            _c("show-tip", {
                              attrs: {
                                module: "auth",
                                tip: "tip_two_factor_security",
                                type: "field",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("switches", {
                              attrs: { theme: "bootstrap", color: "success" },
                              model: {
                                value: _vm.configForm.two_factor_security,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configForm,
                                    "two_factor_security",
                                    $$v
                                  )
                                },
                                expression: "configForm.two_factor_security",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    staticClass: "admin-config-section",
                    attrs: { "aria-label": _vm.trans("auth.login_throttle") },
                  },
                  [
                    _c("h4", { staticClass: "admin-config-section__title" }, [
                      _vm._v(_vm._s(_vm.trans("auth.login_throttle"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "admin-config-section__description" },
                      [
                        _vm._v(
                          "Lock screen and throttle options protect active sessions and repeated login attempts."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-6 form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "" } },
                          [
                            _vm._v(_vm._s(_vm.trans("auth.lock_screen")) + " "),
                            _c("show-tip", {
                              attrs: {
                                module: "auth",
                                tip: "tip_lock_screen",
                                type: "field",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("switches", {
                              attrs: { theme: "bootstrap", color: "success" },
                              model: {
                                value: _vm.configForm.lock_screen,
                                callback: function ($$v) {
                                  _vm.$set(_vm.configForm, "lock_screen", $$v)
                                },
                                expression: "configForm.lock_screen",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.configForm.lock_screen
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("auth.lock_screen_timeout") +
                                        " " +
                                        _vm.trans("auth.in_minute")
                                    ) + " "
                                  ),
                                  _c("show-tip", {
                                    attrs: {
                                      module: "auth",
                                      tip: "tip_lock_screen_timeout",
                                      type: "field",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.lock_screen_timeout,
                                    expression:
                                      "configForm.lock_screen_timeout",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  value: "",
                                  name: "lock_screen_timeout",
                                  placeholder: _vm.trans(
                                    "auth.lock_screen_timeout"
                                  ),
                                },
                                domProps: {
                                  value: _vm.configForm.lock_screen_timeout,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "lock_screen_timeout",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "lock_screen_timeout",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6 form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.trans("auth.login_throttle")) + " "
                            ),
                            _c("show-tip", {
                              attrs: {
                                module: "auth",
                                tip: "tip_login_throttle",
                                type: "field",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("switches", {
                              attrs: { theme: "bootstrap", color: "success" },
                              model: {
                                value: _vm.configForm.login_throttle,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configForm,
                                    "login_throttle",
                                    $$v
                                  )
                                },
                                expression: "configForm.login_throttle",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.configForm.login_throttle
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("auth.login_throttle_attempt")
                                    ) + " "
                                  ),
                                  _c("show-tip", {
                                    attrs: {
                                      module: "auth",
                                      tip: "tip_login_throttle_attempt",
                                      type: "field",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm.login_throttle_attempt,
                                    expression:
                                      "configForm.login_throttle_attempt",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  value: "",
                                  name: "login_throttle_attempt",
                                  placeholder: _vm.trans(
                                    "auth.login_throttle_attempt"
                                  ),
                                },
                                domProps: {
                                  value: _vm.configForm.login_throttle_attempt,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "login_throttle_attempt",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "login_throttle_attempt",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.configForm.login_throttle
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("auth.login_throttle_timeout") +
                                        " " +
                                        _vm.trans("auth.in_minute")
                                    ) + " "
                                  ),
                                  _c("show-tip", {
                                    attrs: {
                                      module: "auth",
                                      tip: "tip_login_throttle_timeout",
                                      type: "field",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm.login_throttle_timeout,
                                    expression:
                                      "configForm.login_throttle_timeout",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  value: "",
                                  name: "login_throttle_timeout",
                                  placeholder: _vm.trans(
                                    "auth.login_throttle_timeout"
                                  ),
                                },
                                domProps: {
                                  value: _vm.configForm.login_throttle_timeout,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "login_throttle_timeout",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "login_throttle_timeout",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "admin-config-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                      attrs: { type: "submit" },
                    },
                    [_vm._v(_vm._s(_vm.trans("general.save")))]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Tune session lifetime, password recovery, lockout, and account security behavior."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }